import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import axios from 'axios';
import {
  Dialog, DialogContent, Tooltip, Button, Typography,
} from '@material-ui/core';

import Filter from '../Filter';

class ModalFilter extends React.Component {
  static propTypes = {
    apiEndpoint: PropTypes.string.isRequired,
    onApply: PropTypes.func,
    onClear: PropTypes.func,
    trigger: PropTypes.node.isRequired,
    tooltipTitle: PropTypes.string,
    initialValues: PropTypes.object,
  };

  static defaultProps = {
    onApply: () => {},
    onClear: PropTypes.func,
    tooltipTitle: '',
    initialValues: {},
  };

  state = {
    dataLoaded: false,
    data: null,
    error: null,
    modalOpened: false,
  };

  async componentDidMount() {
    try {
      const {
        data: { data },
      } = await axios.options(this.props.apiEndpoint);

      this.setState({ dataLoaded: true, data });
    } catch (error) {
      this.setState({ dataLoaded: true, error: error.message });
    }
  }

  handleModalOpened = () => {
    this.setState({ modalOpened: true });
  };

  handleModalClose = () => {
    this.setState({ modalOpened: false });
  };

  render() {
    const {
      trigger, tooltipTitle, onApply, initialValues, onClear,
    } = this.props;

    return [
      <Tooltip key="trigger-node" title={tooltipTitle}>
        {React.cloneElement(trigger, {
          onClick: this.handleModalOpened,
          style: {
            cursor: 'pointer',
          },
        })}
      </Tooltip>,
      <div key="modal-form">
        <Dialog
          open={this.state.modalOpened}
          onClose={this.handleModalClose}
          maxWidth="md"
          fullWidth
        >
          <DialogContent>
            {!this.state.dataLoaded ? (
              <Typography variant="body2" color="secondary">
                Loading...
              </Typography>
            ) : this.state.error ? (
              <Typography variant="body1" color="error">
                {this.state.error}
              </Typography>
            ) : (
              <Filter
                initialValues={initialValues}
                config={this.state.data}
                renderFilterActions={({ filterData, clearFilter }) => (
                  <ButtonContainer>
                    <Button color="primary" onClick={this.handleModalClose}>
                      Close
                    </Button>
                    <Button
                      color="primary"
                      onClick={() => {
                        clearFilter();
                        onClear();
                        this.handleModalClose();
                      }}
                    >
                      Clear
                    </Button>
                    <Button
                      color="primary"
                      onClick={() => {
                        onApply(filterData);
                        this.handleModalClose();
                      }}
                    >
                      Submit
                    </Button>
                  </ButtonContainer>
                )}
              />
            )}
          </DialogContent>
        </Dialog>
      </div>,
    ];
  }
}

export default ModalFilter;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 30px;

  & > * + * {
    margin-left: 20px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ModalFilter/ModalFilter.js